import { render, staticRenderFns } from "./ApplicantDependents.vue?vue&type=template&id=17d5afcb&scoped=true&"
import script from "./ApplicantDependents.vue?vue&type=script&lang=js&"
export * from "./ApplicantDependents.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17d5afcb",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VForm,VIcon,VLayout})


/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/project/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('17d5afcb')) {
      api.createRecord('17d5afcb', component.options)
    } else {
      api.reload('17d5afcb', component.options)
    }
    module.hot.accept("./ApplicantDependents.vue?vue&type=template&id=17d5afcb&scoped=true&", function () {
      api.rerender('17d5afcb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/application/components/Apply/ApplicantDependents.vue"
export default component.exports